import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconUserProfileProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconUserProfile: React.FC<IconUserProfileProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'User Profile'
}) => {
    return (
        <IconBase color={color} size={size} className={className} title={title}>
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.9696 19.5047C16.7257 17.5293 15.0414 16 13 16H11C8.95858 16 7.27433 17.5293 7.03036 19.5047M16.9696 19.5047C19.3986 17.893 21 15.1335 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 15.1335 4.60137 17.893 7.03036 19.5047M16.9696 19.5047C15.5456 20.4496 13.8371 21 12 21C10.1629 21 8.45441 20.4496 7.03036 19.5047M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </IconBase>
    );
};

export default IconUserProfile;

